class AdpSideModalController {
  constructor() {
    this.name = 'adpSideModal';
  }
   close(e) {
    e.stopPropagation();
    this.show = false;
  }
}

export default AdpSideModalController;



// WEBPACK FOOTER //
// ./src/app/components/adpSideModal/adpSideModal.controller.js